import React from "react";
import Modal from "react-responsive-modal";
import { useForm } from "react-hook-form";
import { TextField } from "../../../../../../../../Utils/renderField/fieldsHookForms";

export const ModalTarjetaNoConforme = (props) => {
    const { opened, onClose, onConfirm } = props;

    const {
        control: formControl,
        handleSubmit,
        reset: formReset,
        formState: { errors },
    } = useForm({ mode: "onChange" });

    const handleClose = () => {
        formReset({ tarjeta_salida: "" });
        onClose();
    };

    const onSubmit = (values) => {
        onConfirm(values.tarjeta_salida.trim());
        formReset({ tarjeta_salida: "" });
    };

    return (
        <Modal
            open={opened}
            onClose={handleClose}
            closeOnOverlayClick={false}
            focusTrapped={false}
            // acho máximo
            styles={{
                modal: {
                    maxWidth: "500px",
                    width: "100%",
                },
            }}
        >
            <h4 className="text-center mb-4">Marcar pallet no conforme</h4>

            <div className="formulario-field">
                <label className="text-nowrap">Número de tarjeta roja</label>
                <TextField
                    control={formControl}
                    name="tarjeta_salida"
                    errors={errors}
                    placeholder="Ejemplo: 003-145"
                    rules={{
                        required: "Debe indicar el número de tarjeta",
                        validate: (value) =>
                            !value ||
                            !!value.trim() ||
                            "El número de tarjeta no puede contener solo espacios",
                    }}
                />
            </div>

            <div className="d-flex flex-wrap justify-content-center mt-4 mb-2 gap-1rem">
                <button className="btn btn-outline-dark" onClick={handleClose}>
                    Cancelar
                </button>

                <button
                    className="btn btn-primary"
                    onClick={handleSubmit(onSubmit)}
                >
                    Confirmar
                </button>
            </div>
        </Modal>
    );
};
